
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { Edit, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useQueryClient } from '@tanstack/react-query';
import { EditDiscountDialog } from './EditDiscountDialog';

interface DiscountActionsProps {
  discount: {
    id: number;
    title: string;
    code: string;
    description: string | null;
    status: string;
    discount_type: string;
    discount_percentage: number;
    discount_amount: number | null;
    combinations: boolean;
    valid_until: string | null;
  };
}

export function DiscountActions({ discount }: DiscountActionsProps) {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const handleDelete = async () => {
    const { error } = await supabase
      .from('discount_codes')
      .delete()
      .eq('id', discount.id);

    if (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to delete discount code",
      });
      return;
    }

    toast({
      title: "Success",
      description: "Discount code deleted successfully",
    });

    queryClient.invalidateQueries({ queryKey: ['discounts'] });
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsEditDialogOpen(true)}
      >
        <Edit className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={handleDelete}
      >
        <Trash2 className="h-4 w-4" />
      </Button>

      <EditDiscountDialog
        open={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        discount={discount}
      />
    </div>
  );
}
